export const defaultPageSizeOptions = [10, 25, 50];
export const placeholderOverrideValues = ['0', '0.00', ''];
